import { createSlice } from "@reduxjs/toolkit";


const addressSlice = createSlice({
    name: "address",
    initialState: {
      data: null,
      loading: false,
      error: null,
    },
    reducers: {},
    // extraReducers: (builder) => {
    //   builder
    //     .addCase(fetchAddress.pending, (state) => {
    //       state.loading = true;
    //     })
    //     .addCase(fetchAddress.fulfilled, (state, action) => {
    //       state.loading = false;
    //       state.data = action.payload;
    //     })
    //     .addCase(fetchAddress.rejected, (state, action) => {
    //       state.loading = false;
    //       state.error = action.error.message;
    //     })
    //     .addCase(updateAddress.fulfilled, (state, action) => {
    //       state.data = action.payload; // Update state after successful API call
    //     });
    // },
  });
  
  export default addressSlice.reducer;